const CANONICAL_HOST = 'vitahelm.com'
const LEGACY_HOSTS = new Set(['vitahelm.web.app', 'vitahelm.firebaseapp.com'])
const ORIGIN_BOUND_CALLBACK_PATHS = new Set(['/finance/questrade/callback'])

interface BrowserLocation {
  href: string
  hostname: string
  pathname: string
}

interface CanonicalStartupOptions {
  location: BrowserLocation
  replace: (url: string) => void
  loadApplication: () => Promise<unknown>
  onLoadError: () => void
}

export function canonicalVitaHelmUrl(location: BrowserLocation): string | null {
  if (!LEGACY_HOSTS.has(location.hostname)) return null
  if (ORIGIN_BOUND_CALLBACK_PATHS.has(location.pathname)) return null

  const canonical = new URL(location.href)
  canonical.protocol = 'https:'
  canonical.hostname = CANONICAL_HOST
  canonical.port = ''
  return canonical.toString()
}

export function startCanonicalApplication({
  location,
  replace,
  loadApplication,
  onLoadError,
}: CanonicalStartupOptions): 'redirected' | 'loading' {
  const canonicalUrl = canonicalVitaHelmUrl(location)
  if (canonicalUrl) {
    replace(canonicalUrl)
    return 'redirected'
  }

  void loadApplication().catch(onLoadError)
  return 'loading'
}